// extracted by mini-css-extract-plugin
export default {"headingTitle":"MessageTemplatePopup_headingTitle__0sFF+","actionButtons":"MessageTemplatePopup_actionButtons__wMwzI","addOption":"MessageTemplatePopup_addOption__k6ZXE"};